<template>
  <div class="experience-item">
    <div class="experience-image">
      <div class="slide-image">
        <picture
          :key="`experience-${experience.id}.-image`"
          v-lazyload="{
            src: experience.experienceImage,
            variant: 'experience-list'
          }"
          class="image-wrapper"
        >
          <img
            class="image"
            src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
            :alt="experience.altImg"
          >
        </picture>
        <div
          v-if="experience.isFansOfMOExclusive"
          class="experience-label fan-exclusive"
        >
          {{ dictionary.fansExclusive }}
        </div>
        <div
          v-if="showLabel"
          class="experience-label"
        >
          {{ experience.label }}
        </div>
        <div
          v-if="experience.isFansOfMOEliteExclusive"
          class="experience-label elite-fan-exclusive"
        >
          {{ dictionary.fansEliteExclusive }}
        </div>
      </div>
    </div>
    <div class="experience-content">
      <div class="experience-eyebrow">
        {{ eyebrowData }}
      </div>
      <div class="experience-title">
        {{ experience.experienceTitle }}
      </div>
      <div
        class="experience-description"
        v-html="experience.shortDescription"
      />
    </div>
    <div class="experience-utility">
      <div class="experience-ctas">
        <a
          v-if="experience.secondaryCtaUrl"
          class="experience-cta-secondary"
          :href="experience.secondaryCtaUrl"
          :target="experience.secondaryCtaTarget"
        >
          {{ experience.secondaryCtaLabel || dictionary.purchase }}
        </a>
        <a
          class="experience-cta-primary"
          :href="experience.url"
        >{{ dictionary.seeDetails }}</a>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'ExperienceCard',
    components: {

    },
    props: {
      filter: {
        type: String,
        default: null
      },
      eyebrowSource: {
        type: String,
        default: null
      },
      dictionary: {
        type: Object,
        required: true,
        default: () => ({})
      },
      experience: {
        type: Object,
        required: true,
        default: () => ({})
      },
    },
    computed: {
      ...mapState('responsive', { wWidth: 'width', wHeight: 'height' }),
      ...mapGetters('i18n', ['tc']),

      showLabel() {
        return this.experience.label !== ''
      },

      eyebrowData() {
        return this.eyebrowSource === 'City' ? this.experience.property?.name : this.experience.categories[0]?.label
      }
    },
  }
</script>
